import { Button } from '@mui/material'
import { LastEquipmentInteractionDto, OperationalEquipmentDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { IFormStore, PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Breadcrumbs, BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'
import { IOperationalEquipmentFormData } from '../../models/operational-equipment-assignment.model'
import { OperationalEquipmentConfirm } from '../molecules/OperationalEquipmentConfirm'
import { OperationalEquipmentLastInteraction } from '../molecules/OperationalEquipmentLastInteraction'
import { OperationalEquipmentSelectionDetails } from '../molecules/OperationalEquipmentSelectionDetails'

interface Props {
  operationalEquipments: OperationalEquipmentDto[]
  lastInteraction?: LastEquipmentInteractionDto
  formStore: IFormStore<IOperationalEquipmentFormData>
  onSubmit: () => Promise<void>
}
export const OperationalEquipmentFormHeader = observer(
  ({ operationalEquipments, lastInteraction, formStore, onSubmit }: Props) => {
    const navigate = useNavigate()
    const { t } = useTranslate()

    const action = t('edit', 'Edit')

    const breadCrumbs: BreadcrumpItem[] = useMemo(() => {
      return [
        {
          label: t(PATHS.controlRoom.operationalEquipment.title),
          onClick: () => navigate(PATHS.controlRoom.operationalEquipment.url),
        },
        {
          label: action,
        },
      ]
    }, [t, action, navigate])

    return (
      <>
        <Breadcrumbs items={breadCrumbs} />
        <Header
          title={action}
          position='relative'
          rightRenderOption={
            <>
              <Button
                variant='text'
                color='inherit'
                data-cy='cancel-operational-equipment-btn'
                onClick={() => navigate(PATHS.controlRoom.operationalEquipment.url)}
              >
                {t('cancel', 'Cancel')}
              </Button>
              {operationalEquipments.length > 0 && (
                <OperationalEquipmentConfirm
                  equipmentCount={operationalEquipments.length}
                  equipmentType={operationalEquipments[0].equipmentType}
                  formStore={formStore}
                  onConfirm={onSubmit}
                />
              )}
            </>
          }
        />
        {operationalEquipments.length === 1 ? (
          <OperationalEquipmentLastInteraction lastInteraction={lastInteraction} />
        ) : (
          <OperationalEquipmentSelectionDetails operationalEquipments={operationalEquipments} />
        )}
      </>
    )
  },
)
